import React from 'react';
import { C, F, Pill } from '../theme/uiKit';

/**
 * Supplier Gateway · Promised Date. The feature is still under development, so
 * this shows an "under development" placeholder.
 */
export default function PromisedDateScreen() {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 24,
                fontFamily: F.ui,
                minHeight: 360,
            }}
        >
            <div style={{ maxWidth: 460, textAlign: 'center' }}>
                <div style={{ fontSize: 44, marginBottom: 14 }}>🚧</div>
                <div style={{ marginBottom: 12 }}>
                    <Pill label="Under development" color="amber" dot />
                </div>
                <h1 style={{ margin: '0 0 8px', fontSize: 24, fontWeight: 700, color: C.text }}>
                    Promised Date
                </h1>
                <p style={{ margin: 0, fontSize: 15, color: C.textSub, lineHeight: 1.6 }}>
                    This feature is still being developed and isn&rsquo;t available yet. For access
                    or timelines, please check with your administrator.
                </p>
            </div>
        </div>
    );
}
